
import React from 'react';
import { SettingsActions } from './SettingsActions';

interface SettingsHeaderProps {
  onButtonClick: (e: React.MouseEvent) => void;
  onDeleteClick: () => void;
}

export function SettingsHeader({ onButtonClick, onDeleteClick }: SettingsHeaderProps) {
  return (
    <div className="flex justify-between items-start">
      <div className="space-y-1">
        <h3 className="text-lg font-medium">Assessment Settings</h3>
        <p className="text-sm text-muted-foreground">
          Configure your assessment settings and preferences
        </p>
      </div>
      <SettingsActions onButtonClick={onButtonClick} onDeleteClick={onDeleteClick} />
    </div>
  );
}
